import 'bootstraps'; // It must be the first line of an entry point
import '@app/libs/browserCompatibility';
import 'moment/locale/ko';
import 'normalize.css';
import 'libs/i18next';
import 'react-day-picker/dist/style.css';
// 로컬에서 빌드 후 스테이지에 배포 했을 때 CORS 오류가 나는 경우가 있어 주석처리합니다.
import './libs/mocks';

import moment from 'moment';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import ReactModal from 'react-modal';

import AppErrorFallback from '@app/components/AppErrorFallback';
import { tryKakaoAutoLogin } from '@app/hooks/useKakaoAutoLogin';
import { activateAnalytics } from '@app/libs/analytics/activateAnalytics';
import { setDatadogUser } from '@app/libs/datadog';
import { setDateFnsDefaultLocale } from '@app/libs/dateFns';
import { initGoogleTranslateDebugger } from '@app/libs/googleTranslateDebugger';
import { logger } from '@app/libs/logger';

import { initializeApi, initializeOpenApiClient } from './api/initializeApi';
import Root from './components/Root';
import { ROOT, ROOT_ID } from './constants/globalSelector';
import printModusignRecruitment from './libs/recruit';
import reportWebVitals from './reportWebVitals';

import '@modusign/design-system/scss/modal.scss';
import '@modusign/design-system/scss/toast.scss';
import './scss/style.scss';

/**
 * Axios 초기화
 */
initializeOpenApiClient();
initializeApi();

setDatadogUser();

tryKakaoAutoLogin();

moment.locale(window.navigator.language || 'ko');

setDateFnsDefaultLocale();

ReactModal.setAppElement(ROOT_ID);

ReactDOM.render(
  <ErrorBoundary
    FallbackComponent={AppErrorFallback}
    onError={(error) => {
      logger.error(`Unhandled error catched at root ErrorBoundary: ${error.message}`, {}, error);
    }}
  >
    <Root />
  </ErrorBoundary>,
  document.getElementById(ROOT)
);

activateAnalytics();
printModusignRecruitment();
initGoogleTranslateDebugger();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
